import script from "./DestinationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationSection.vue?vue&type=script&setup=true&lang=js"

import "./DestinationSection.vue?vue&type=style&index=0&id=7e654bc5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e654bc5"]])

export default __exports__